// Zone recalculation writes both roofZone and edgeType. The tech-upgrade
// UPDATE_PANELS(..., { type: 'roofZone' }) path used to copy only roofZone,
// which dropped E/R/N labels after every add/load.
export function getPanelUpdatePatch(foundPanel: panelInState, updateType?: string) {
  if (updateType === 'roofZone') {
    const patch: { roofZone?: roofZoneNumber, edgeType?: number } = {};
    // A later classification job can miss disconnected RMDT arrays that were
    // still sharing the first array's groupId. Do not copy an empty zone over
    // colors that a previous job already applied.
    if (foundPanel.roofZone != null) {
      patch.roofZone = foundPanel.roofZone;
    }
    if (foundPanel.edgeType !== undefined) {
      patch.edgeType = foundPanel.edgeType;
    }
    return patch;
  }
  if (updateType) {
    return { [updateType]: foundPanel[updateType] };
  }
  return foundPanel;
}
